export default (name: string) => {
  const data = [
    { name: 'Tor Silesia Ring Karting', replace: 'Tor Silesia Ring Karting - Opole' },
    { name: 'Tor Silesia Ring karting', replace: 'Tor Silesia Ring Karting - Opole' },
    { name: 'Tor Silesia Ring', replace: 'Tor Silesia Ring - Opole' },
    { name: 'Tor Modlin', replace: 'Tor Modlin - Warszawa' },
    { name: 'Tor Ułęż', replace: 'Tor Ułęż - Lublin' },
    { name: 'Tor Krzywa', replace: 'Tor Krzywa - Wrocław' },
    { name: 'Tor Poznań', replace: 'Tor Poznań' },
    { name: 'Tor Poznań karting', replace: 'Tor Poznań Karting' },
    { name: 'Tor Toruń', replace: 'Tor Toruń' },
    { name: 'Tor Bednary', replace: 'Tor Bednary - Poznań' },
    { name: 'Tor Pszczółki', replace: 'Tor Pszczółki - Gdańsk' },
    { name: 'Tor Słomczyn', replace: 'Tor Słomczyn - Warszawa' },
    { name: 'Tor Jastrząb', replace: 'Tor Jastrząb - Radom' },
    { name: 'Tor Jastrząb Radom', replace: 'Tor Jastrząb - Radom' },
    { name: 'Tor Kielce', replace: 'Tor Kielce - Miedziana Góra' }
  ]
  const el = data.find(el => el.name === name)
  return el ? el.replace : name
}
